<template>
  <div class="picmanger">
    <div class="header">
      <div style="display: flex; align-items: center">
        <img
          src="@/assets/house/breadicon.png"
          style="margin-right: 10px"
          alt
        />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>数智中心</el-breadcrumb-item>
          <el-breadcrumb-item>数据统计</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <!-- <div @click="refresh" class="refresh">
        <img
          :class="isRefresh ? 'imgmove' : ''"
          width="16px"
          height="16px"
          src="@/assets/house/refresh.png"
          alt
        />
        <p>刷新</p>
      </div> -->
    </div>

    <div class="main" v-loading="isRefresh">
      <div class="head">
        <h4>数据统计</h4>
      </div>
      <div class="search-header" style="position: relative;z-index: 2;min-width: 700px;">
        <div style="height: 32px;width: 100%">
          <div  style="width: 100%;display: flex; justify-content: space-between;">
              <div style="display: flex; justify-content: flex-start;gap: 20px;">
                <el-radio-group v-model="chartType">
                  <el-radio-button label="全部"></el-radio-button>
                  <el-radio-button label="月度"></el-radio-button>
                  <el-radio-button label="年度"></el-radio-button>
                </el-radio-group>
                <el-date-picker
                v-show="chartType=='月度'"
                :clearable="false"
                  v-model="selectMonth"
                  type="month"
                  format="yyyy 年 MM 月"
                  value-format="yyyy-MM"
                  placeholder="请选择月份">
                </el-date-picker>
                <el-date-picker
                v-show="chartType=='年度'"
                  v-model="selectYear"
                  :clearable="false"
                  type="year"
                  format="yyyy 年"
                  value-format="yyyy"
                  placeholder="选择年份">
                </el-date-picker>
              </div>
              <div>
                <el-button type="primary" icon="el-icon-upload2" @click="exportExcel()">导出</el-button>
                <el-button  type="primary" icon="el-icon-search" @click="search()">查询</el-button>
                <el-button type="danger" @click="reset()" icon="el-icon-refresh">重置</el-button>
              </div>
          </div>
        </div>
      </div>

      
      <div class="tablebg" style="position: relative;z-index: 1;">
        <com-table
          ref="comTable"
          :columns="columns"
          :data="tableList"
          :height="tableHeight"
          :show-summary='showSummary'
          :pagination="pagination"
          @getData="fetchTableList"
          :loading="loading"
          >
          <!-- <template slot="sharePic" slot-scope="scope">
            <el-button type="text" >查看详情</el-button>
            1122333
          </template> -->
        </com-table>
      </div>
    </div>
  </div>
</template>

<script>

import { comTable } from '@/components/index';
import { picPrefix } from "@/constants/piccommon";

// import vns from 'vue-number-scroll'
// import { getOverview } from '@/api/resourceLog'
// import { dataecharts } from '@/components/index'
// import { formatConversion } from '@/plugins/getdate'

import { getDepartmentShareListApi } from '@/api/department'
export default {
  name:'datastatic',
  components: {
    comTable,
    // 'vns':vns,
    // 'data-echarts':dataecharts
  },
  data() {
    return {
      picPrefix,
      isExport:0,
      showSummary:true,
      chartType: '全部',
      type: 0,
      data:'',
      selectMonth: '',
      selectYear: '',
      tableHeight:600,
      // formatConversion,
      isRefresh: false,
      loading: true,
      columns: [
        { prop: 'name', label: '部门', width: 200 },
        // { slot: 'sharePic', label: '操作' ,width: 160},
        { prop: 'picCount', label: '共享图片量', minWidth: 160 },
        { prop: 'videoCount', label: '共享视频量', minWidth: 160},
        { prop: 'points', label: '积分', minWidth: 160},
        // { slot: 'operation', label: '操作' ,width: 160}
      ],
      tableList: [],
      pagination: {
        current: 1,
        size: 10,
        total: 20
      }
      
    };
  },
  methods: {
    exportExcel() {
      this.$confirm(`当前导出内容是搜索的所有【统计数据】,是否继续？`,'导出提示', {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(e => {
          this.isExport = 1
          this.fetchTableList()
        })
        .catch(e => {
          
        });
    },
    reset() {
      let currentYear = new Date().getFullYear();
      let currentMonth = new Date().getMonth() + 1;
      this.chartType='全部'
      this.selectMonth =currentYear+'-'+ currentMonth;
      this.selectYear = currentYear + '';
      this.fetchTableList()
    },
    search() {
      this.fetchTableList()
    },

    async fetchTableList() {
      let params = {
        page: this.pagination.current,
        pageSize: this.pagination.size,
      }
      if (this.isExport) {
        params.isExport=this.isExport
      }
      if (this.chartType!=='全部') {
        params.type = this.chartType == '月度' ? 'month' : 'year'
        if (this.chartType == '月度') {
          console.log(this.selectMonth);
          params.date = this.selectMonth
        } else {
          console.log(this.selectYear);
          params.date = this.selectYear
        }
      }
      if (!this.isExport) {
        this.loading = true
      }
    // 分页时触发表单数据请求
      console.log(this.pagination)
      
      let {data,status,message,pagination} = await getDepartmentShareListApi(params)
      console.log(data.list);
      if (status) {
        if (!this.isExport) {
          this.loading = false
          this.tableList = data.list;
          this.pagination.total = pagination.total;
        
        } else {
          this.isExport = 0
          this.$message.success({ message: `${message}请耐心等待...` })
          let downLoadUrl = this.picPrefix + data;
          console.log(downLoadUrl);
          let a = document.createElement("a");
          a.href = downLoadUrl;
          window.open(a.href, '_blank');
        }
      } else {
        this.$message.error(message)
      }
    },
    
  
  },
  created() {
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth() + 1;
    this.selectMonth =currentYear+'-'+ currentMonth;
    this.selectYear = currentYear+'';
    // this.isRefresh = true
    // this.getOverviewasync()
    this.fetchTableList();
    
  },
  beforeDestroy() {
    // 组件销毁前调用
  },
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./datastatic.scss";
</style>
